import slide1 from "../../assets/dashboard/sid-slider/slider-img3.png";
import slide2 from "../../assets/dashboard/sid-slider/slider-img2-1-1.png";
import "../style/dashboard/Sid_Slider.css";

let slider_list = [
  {
    id: 1,
    img: slide1,
    title: "اولین بوت کمپ برنامه نویسی اندروید",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
  {
    id: 2,
    img: slide2,
    title: "اولین بوت کمپ تصویرسازی",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
  {
    id: 3,
    img: slide1,
    title: "اولین بوت کمپ برنامه نویسی جاوا",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
  {
    id: 4,
    img: slide2,
    title: "اولین بوت کمپ طراحی کاراکتر",
    subtitle: "فرصتی بی‌نظیر برای ثبت نام مدارس",
  },
];
const Sid_Slider = () => {
  const intial_changes = () => {
    let st = document.querySelectorAll(".slide-title");
    st[0].classList.add("slide-title-show");

    let ss = document.querySelectorAll(".slide-subtitle");
    ss[0].classList.add("slide-title-show");

    let btn = document.querySelectorAll(".slide-btn");
    btn[0].classList.add("slide-btn-show");
  };

  let old_bar_item = 0;
  const slider_move1 = () => {
    if (old_bar_item !== 0) {
      document.querySelectorAll(".slider-sit-bar-item")[0].style.opacity = 1;
      document.querySelectorAll(".slider-sit-bar-item")[
        old_bar_item
      ].style.opacity = 0.3;
    }
    let slide = document.querySelectorAll(".slide");
    slide[0].style.transform = "translateX(0)";
    slide[1].style.transform = "translateX(100%)";
    slide[2].style.transform = "translateX(200%)";
    slide[3].style.transform = "translateX(300%)";
    //title transition----------
    let st = document.querySelectorAll(".slide-title");
    st[0].classList.add("slide-title-show");
    st[1].classList.remove("slide-title-show");
    st[2].classList.remove("slide-title-show");
    st[3].classList.remove("slide-title-show");
    //subtitle transition----------
    let ss = document.querySelectorAll(".slide-subtitle");
    ss[0].classList.add("slide-title-show");
    ss[1].classList.remove("slide-title-show");
    ss[2].classList.remove("slide-title-show");
    ss[3].classList.remove("slide-title-show");
    //btn transition----------
    let btn = document.querySelectorAll(".slide-btn");
    btn[0].classList.add("slide-btn-show");
    btn[1].classList.remove("slide-btn-show");
    btn[2].classList.remove("slide-btn-show");
    btn[3].classList.remove("slide-btn-show");

    old_bar_item = 0;
  };
  const slider_move2 = () => {
    if (old_bar_item !== 1) {
      document.querySelectorAll(".slider-sit-bar-item")[1].style.opacity = 1;
      document.querySelectorAll(".slider-sit-bar-item")[
        old_bar_item
      ].style.opacity = 0.3;
    }
    let slide = document.querySelectorAll(".slide");
    slide[0].style.transform = "translateX(-100%)";
    slide[1].style.transform = "translateX(0)";
    slide[2].style.transform = "translateX(100%)";
    slide[3].style.transform = "translateX(200%)";
    //title transition----------
    let st = document.querySelectorAll(".slide-title");
    st[1].classList.add("slide-title-show");
    st[0].classList.remove("slide-title-show");
    st[2].classList.remove("slide-title-show");
    st[3].classList.remove("slide-title-show");
    //subtitle transition----------
    let ss = document.querySelectorAll(".slide-subtitle");
    ss[1].classList.add("slide-title-show");
    ss[0].classList.remove("slide-title-show");
    ss[2].classList.remove("slide-title-show");
    ss[3].classList.remove("slide-title-show");
    //btn transition----------
    let btn = document.querySelectorAll(".slide-btn");
    btn[1].classList.add("slide-btn-show");
    btn[0].classList.remove("slide-btn-show");
    btn[2].classList.remove("slide-btn-show");
    btn[3].classList.remove("slide-btn-show");

    old_bar_item = 1;
  };
  const slider_move3 = () => {
    if (old_bar_item !== 2) {
      document.querySelectorAll(".slider-sit-bar-item")[2].style.opacity = 1;
      document.querySelectorAll(".slider-sit-bar-item")[
        old_bar_item
      ].style.opacity = 0.3;
    }
    let slide = document.querySelectorAll(".slide");
    slide[0].style.transform = "translateX(-200%)";
    slide[1].style.transform = "translateX(-100%)";
    slide[2].style.transform = "translateX(0)";
    slide[3].style.transform = "translateX(100%)";
    //title transition----------
    let st = document.querySelectorAll(".slide-title");
    st[2].classList.add("slide-title-show");
    st[0].classList.remove("slide-title-show");
    st[1].classList.remove("slide-title-show");
    st[3].classList.remove("slide-title-show");
    //subtitle transition----------
    let ss = document.querySelectorAll(".slide-subtitle");
    ss[2].classList.add("slide-title-show");
    ss[0].classList.remove("slide-title-show");
    ss[1].classList.remove("slide-title-show");
    ss[3].classList.remove("slide-title-show");
    //btn transition----------
    let btn = document.querySelectorAll(".slide-btn");
    btn[2].classList.add("slide-btn-show");
    btn[0].classList.remove("slide-btn-show");
    btn[1].classList.remove("slide-btn-show");
    btn[3].classList.remove("slide-btn-show");

    old_bar_item = 2;
  };
  const slider_move4 = () => {
    if (old_bar_item !== 3) {
      document.querySelectorAll(".slider-sit-bar-item")[3].style.opacity = 1;
      document.querySelectorAll(".slider-sit-bar-item")[
        old_bar_item
      ].style.opacity = 0.3;
    }
    let slide = document.querySelectorAll(".slide");
    slide[0].style.transform = "translateX(-300%)";
    slide[1].style.transform = "translateX(-200%)";
    slide[2].style.transform = "translateX(-100%)";
    slide[3].style.transform = "translateX(0)";
    //title transition----------
    let st = document.querySelectorAll(".slide-title");
    st[3].classList.add("slide-title-show");
    st[2].classList.remove("slide-title-show");
    st[1].classList.remove("slide-title-show");
    st[0].classList.remove("slide-title-show");
    //subtitle transition----------
    let ss = document.querySelectorAll(".slide-subtitle");
    ss[3].classList.add("slide-title-show");
    ss[2].classList.remove("slide-title-show");
    ss[1].classList.remove("slide-title-show");
    ss[0].classList.remove("slide-title-show");
    //btn transition----------
    let btn = document.querySelectorAll(".slide-btn");
    btn[3].classList.add("slide-btn-show");
    btn[2].classList.remove("slide-btn-show");
    btn[1].classList.remove("slide-btn-show");
    btn[0].classList.remove("slide-btn-show");

    old_bar_item = 3;
  };
  return (
    <div className="sid_slider" onLoad={intial_changes}>
      {slider_list.map((item) => (
        <div key={item.id} className="slide">
          <img src={item.img} alt="slide1" />
          <div className="slide-info">
            <div className="slide-title">{item.title}</div>
            <div className="slide-subtitle">{item.subtitle}</div>
            <div className="slide-btn">اطلاعات بیشتر</div>
          </div>
        </div>
      ))}
      <div className="slider-sit-bar">
        <div className="slider-sit-bar-item" onClick={slider_move1}></div>
        <div className="slider-sit-bar-item" onClick={slider_move2}></div>
        <div className="slider-sit-bar-item" onClick={slider_move3}></div>
        <div className="slider-sit-bar-item" onClick={slider_move4}></div>
      </div>
    </div>
  );
};

export default Sid_Slider;
